import React from 'react';
import { SystemState } from '../../store/system/types';
import ProgressiveForm from '../Forms/ProgressiveForm';
import * as Yup from 'yup';
import { FlowProps } from './HOCProps';

interface FlowState {
    pages: any[]
    currentPage: number,
    showMessage: boolean,
    errorMessage: React.ReactElement | null
}
interface FlowHOCProps<TFormSchema> {
    formValues: TFormSchema,
    system?: SystemState,
    validationSchema : Yup.Schema<TFormSchema>
}

export const withFlow = <TFormSchema extends any>(
    Component: React.ComponentType<FlowProps<TFormSchema>>,
  ) => class Flow extends React.Component<FlowHOCProps<TFormSchema>, FlowState> {
      constructor(props: FlowHOCProps<TFormSchema>) {
          super(props);
          this.state = {
              pages: [],
              currentPage: 0,
              showMessage: true,
              errorMessage: null
          };
          this.nextPage = this.nextPage.bind(this);
          this.previousPage = this.previousPage.bind(this);
          this.changePage = this.changePage.bind(this);
      }
      nextPage(desiredPage: number = -1) {
            let nextPage: number = this.state.currentPage + 1;
            if (desiredPage >= 0){
                nextPage = desiredPage;
            }
            this.changePage(20, nextPage);
      }
      previousPage(desiredPage: number = -1) {
            let nextPage: number = this.state.currentPage - 1;
            if (desiredPage >= 0){
                nextPage = desiredPage;
            }
            this.changePage(0, nextPage);
      }
      changePage(limitPage: number, desiredPage: number){
        if (this.state.currentPage === limitPage)
            return;
        this.setState({ showMessage: !this.state.showMessage });

        setTimeout(() => {
            this.setState({ showMessage: !this.state.showMessage });
            this.setState({ currentPage: desiredPage });
        }, 300)
      }
      render() {
          return (
              <ProgressiveForm<TFormSchema>
                  initialValues={this.props.formValues}
                  nextPage={this.nextPage}
                  previousPage={this.previousPage}
                  currentStep={this.state.currentPage}
                  validationSchema={this.props.validationSchema as any}
                  showMessage={this.state.showMessage}
                  component={Component}
              />
          )
      }
  }